 // object of  style objects , cintainer, header,etc 
 export  const styleGrid = (windowWidth) => {
    return {
        container: {
            minHeight: '100vh',
            backgroundColor: 'transparent'
        },
        header: {
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: 'rgba(213, 213, 213, 0.95)',
            backdropFilter: 'blur(10px)'
        },
        headerContent: {
            maxWidth: '1280px',
            margin: '0 auto',
            padding: windowWidth < 640 ? '24px 16px' : '24px 48px'
        },
        headerTop: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        title: {
            fontSize: windowWidth < 640 ? '30px' : '36px',
            fontWeight: 'bold',
            color: '#191919',
            margin: 0,
            letterSpacing: '-0.02em'
        },
        subtitle: {
            marginTop: '8px',
            fontSize: windowWidth < 640 ? '14px' : '16px',
            color: '#686868',
            margin: '8px 0 0 0'
        },
        closeButton: {
            position: ' absolute',
            top: '1px',
            right:'10px',
            padding: '8px',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        main: {
            maxWidth: '1280px',
            margin: '0 auto',
            padding: windowWidth < 640 ? '32px 16px' : windowWidth < 1024 ? '48px 24px' : '48px 32px'
        },
        gridContainer: {
            display: 'grid',
            gridTemplateColumns: windowWidth < 640 ? '1fr' : windowWidth < 1024 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            gap: windowWidth < 640 ? '24px' : '32px'
        },
        galleryItem: {
            cursor: 'pointer'
        },
        // div of the painitng 
        imageContainer: {
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '8px',
            backgroundColor: 'transparent',
            border:'1px solid #cacad7',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'box-shadow 0.3s, transform 0.3s'
        },
        image: {
            // width: '100%',
            display: 'block',
            margin:'0 auto',
            height: '100%',
            maxWidth:'100%',
            objectFit: 'cover',
            transition: 'transform 0.5s'
        },
        imageOverlay: {
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent, transparent)',
            opacity: 0,
            transition: 'opacity 0.3s',
            pointerEvents: 'none'
        },
        overlayContent: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: '16px',
            color: 'white'
        },
        overlayTitle: {
            fontWeight: '600',
                fontSize: '18px',
                    margin: 0
        },
        overlayYear: {
            fontSize: '14px',
            opacity: 0.9,
            margin: '4px 0 0 0'
        },
        details: {
            marginTop: '16px'
        },
        detailTitle: {
            fontWeight: '600',
            fontSize: '18px',
            color: '#191919',
            margin: '0 0 4px 0'
        },
        detailText: {
            fontSize: '14px',
                color: '#686868',
                    margin: '4px 0'
        },
        slideshowContainer: {
            position: 'relative',
            width: '100%',
            minHeight: '100vh',
            zIndex: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            overflow: 'hidden'
        },
        navButton: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10,
            padding: windowWidth < 640 ? '12px' : '16px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            border: 'none',
            boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
            cursor: 'pointer',
            transition: 'all 0.2s',
            display: 'flex',
                alignItems: 'center',
                    justifyContent: 'center'
        },
        prevButton: {
            left: '16px'
        },
        nextButton: {
            right: '16px'
        },
        slideshowContent: {
            maxWidth: '1280px',
            width: '90%',
            height: '100vh',
            margin: '0 auto',
            padding: windowWidth < 640 ? '96px 16px 128px' : '16px 12px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        },
        slideshowImageContainer: {
            position: 'relative',
            width: '100%',
            height: 'calc(100vh - 150px)',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 1
        },
        slideshowImage: {
            display: 'block',
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)'
        },
        slideshowDetails: {
            marginTop: '32px',
            textAlign: 'center'
        },
        slideshowTitle: {
            fontSize: windowWidth < 640 ? '16px' : '20px',
            fontWeight: 'bold',
            color: '#191919',
            margin: '0 0 8px 0'
        },
        slideshowText: {
            fontSize: windowWidth < 640 ? '14px' : '16px',
            color: '#686868',
            margin: '8px 0'
        },
        slideshowSmallText: {
            fontSize: windowWidth < 640 ? '10px' : '12px',
            color: '#686868',
            margin: '8px 0'
        },
        counter: {
            fontSize: '14px',
            color: '#686868',
            marginTop: '16px'
        },
        thumbnailStrip: {
            display:'none',
            // test 
            border:'2px solid pink',
            position: 'absolute',
            bottom: '16px',
            left: 0,
            right: 0,
            overflowX: 'auto'
        },
        thumbnailContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
            padding: '0 16px 8px'
        },
        thumbnail: {
            flexShrink: 0,
            width: windowWidth < 640 ? '64px' : '80px',
            height: windowWidth < 640 ? '64px' : '80px',
            borderRadius: '6px',
            overflow: 'hidden',
            border: '2px solid transparent',
            transition: 'all 0.2s',
            cursor: 'pointer',
            backgroundColor: 'transparent',
            padding: 0
        },
        thumbnailActive: {
            border: '2px solid #191919',
            transform: 'scale(1.1)'
        },
        thumbnailInactive: {
            opacity: 0.6
        },
        thumbnailImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        loadingContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#E5E5E5'
        },
        loadingText: {
            fontSize: '14px',
            color: '#686868',
            animation: 'pulse 2s ease-in-out infinite'
        }
    }
 };